import {
  Injectable
} from "@angular/core";
import {
  BehaviorSubject
} from "rxjs";


@Injectable({
  providedIn: "root",
})
export class NavBarService {

  private collapse$ = new BehaviorSubject <boolean> (false);
  private collapseKnowledge$ = new BehaviorSubject <boolean> (false);

  isCollapsed$ = this.collapse$.asObservable();
  isCollapseKnowledge$ = this.collapseKnowledge$.asObservable();
  private _isSmallDevice = false;
  private STORAGE_KEY='menu-toggled';

  
  constructor() {
   
     let value=localStorage.getItem(this.STORAGE_KEY);
     if(value)
       this.collapse$.next(value == '1' ? true:false);
  }

  toggle() {

    if (!this._isSmallDevice)
    {
       this.collapse$.value ? this.expand() : this.collapse();
    }
  }

  private _setState()
  {
    localStorage.setItem(
      this.STORAGE_KEY,
      this.collapse$.value ? '1' : '0'
    );
  }

  collapse() {
    this.collapse$.next(true);
    this._setState();
  }
  collapseKnowledge() {
    this.collapseKnowledge$.next(true);
  }
  expand() {
    this.collapse$.next(false);
    this._setState();
  }
  expandKnowledge() {
    this.collapseKnowledge$.next(false);
  }
  toggleKnowledge() {

    if (!this._isSmallDevice)
    {
       this.collapseKnowledge$.value ? this.expandKnowledge() : this.collapseKnowledge();
    }
  }

  isCollapsed(): boolean {
    return this.collapse$.value
  }
  isCollapsedKnowledge(): boolean {
    return this.collapseKnowledge$.value
  }

  isSmallDevice(innerWidth) {
    this._isSmallDevice = innerWidth < 992;
    if (this._isSmallDevice) {
      this.collapse();
    }
  }

  onWindowsResize(innerWidth: number) {
    this.isSmallDevice(innerWidth);
  }
}
